import * as Sentry from "@sentry/react";
import { environment, variablesGlobales } from "./variables";

const dsn = variablesGlobales.glitchtipDsn;

export function initSentry() {
    Sentry.init({
        dsn,
        environment,
        enabled: Boolean(dsn) && environment !== "LOCAL",
        tracesSampleRate: environment === "PROD" ? 0.1 : 0.01,
        autoSessionTracking: false, // GlitchTip no soporta sessions
        // Inyectado por el navegador embebido de Facebook/Instagram, no por el código del repo
        ignoreErrors: [/_META/, /IABInnerFrame/],
    });
}

// GlitchTip pisa el usuario completo en cada setUser(), así que acumulamos
// aquí lo que cada contexto (Auth, CreditUser) va conociendo del visitante.
let sentryUser = {};

export function mergeSentryUser(partial) {
    sentryUser = { ...sentryUser, ...partial };
    Sentry.setUser(sentryUser);
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;

// Ante un ChunkLoadError (despliegue nuevo con archivos viejos en caché) recarga UNA vez por sesión
export function reloadOnChunkError(error) {
    try {
        const isChunkError = error?.name === "ChunkLoadError" || /Loading chunk .* failed/i.test(error?.message ?? "");
        if (!isChunkError) return;
        if (sessionStorage.getItem("chunk_reload_done")) return;
        sessionStorage.setItem("chunk_reload_done", "1");
        window.location.reload();
    } catch (reloadError) {
        // sessionStorage puede no estar disponible
    }
}
